import React from "react";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const FeaturedQuote = ({ content }) => {
  const { description, author, position, photo } = content;
  return (
    <div id="FeaturedQuote">
      <div className="wrap">
        <div className="photo">
          <img src={photo.url} alt="featuredPhoto" />
        </div>
        <div className="contentContainer">
          <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
          <div className="text author">{author}</div>
          <div className="text">{position}</div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedQuote;
